import { InputNumberField } from '@tempmee/react';
import React, { useRef } from 'react';
import CustomPortal from '../../commonComponents/CustomPortal';

export default ({ onClose, onSubmit }) => {
  const amountRef = useRef(0);

  const handleInputChange = (e) => {
    amountRef.current = Number(e.target.value);
  };

  return (
    <CustomPortal
      title="Counter Cover (Gotu Contribution)"
      containerStyle={{
        width: '800px',
      }}
      text={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            padding: '0 16px',
            textAlign: 'left',
          }}
        >
          <span>
            Use this field to input a counter cover discount for this shift. Any applied discount
            will be tracked and removed from this shift&apos;s revenue. Check with your manager for
            budgets and limitations.
          </span>

          <span>How does it work:</span>
          <ul>
            <li>Enter the total counter cover amount ($ counter cover per hour * # hours)</li>
            <li>Maximum counter cover is $32.00</li>
            <li>
              Discounts can only be applied to open & pending/counter shifts. The office will see
              the discount on the Confirm Candidate page.
            </li>
            <li>
              If a discount was applied and the professional cancels the shift, the discount will be
              removed and will not apply to the re-filled professional unless the discount is
              re-applied.
            </li>
            <li>Discounts can only be applied less than 28 days before the shift date. </li>
          </ul>

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <b>Total Amount:</b>
            <InputNumberField
              leftIcon="$"
              min={0}
              step={0.01}
              defaultValue={0}
              onChange={handleInputChange}
              style={{ width: '120px' }}
            />
          </div>
        </div>
      }
      textStyle={{ textAlign: 'center' }}
      submitText="Apply Counter Cover"
      cancelText="Go Back"
      submitPressed={() => onSubmit(amountRef.current)}
      cancelPressed={onClose}
    />
  );
};
